module.exports = __webpack_public_path__ + "img/user.5a29eab8.webp";